var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"region-placeholder text-center"},[_c('v-icon',{staticClass:"mb-3",attrs:{"size":"56","color":"#b0bec5"}},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"subtitle-1 font-weight-medium mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"region-placeholder__text mb-0"},[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }